import { useEffect, useState } from 'react'
import AttacthmentIcon from '../../../../media/shared-access/ic-attachment.svg'
import '../style/replyemail.scss'
import { useIntl } from 'react-intl'
import { useAuth } from '../../auth'
import { useLocation, useNavigate } from 'react-router-dom'
import { createAiComposeEmail, createMessage } from '../core/_requests'
import { toast } from 'react-toastify'
import { ErrorMessage, Field } from 'formik'
import { InboxQuill } from './InboxQuill'
import { FileUpload } from '../../widgets/components/FileUpload'
import docIcon from '../../../../media/shared-access/ic_doc.svg'
import pdfIcon from '../../../../media/shared-access/ic_pdf.svg'
import imgIcon from '../../../../media/shared-access/ic-image.svg'
import deleteicon from '../../../../media/shared-access/ic-delete_red.svg'
import Skeleton from 'react-loading-skeleton'
import { DateTime } from 'luxon'
import WriteWithAI from './write-with-AI'

const ReplyEmail = ({
  userInfo,
  setEmailStatus,
  formik,
  providerEmailId,
  subject,
  lastEmail,
  emailLoading,
  setShowEmail,
  showEmail,
  isForwardEmailClick,
  setIsForwardEmailClick,
  providerThreadId,
}: any) => {
  const { formatMessage } = useIntl()
  const [showCc, setShowCc] = useState(false)
  const [showBcc, setShowBcc] = useState(false)
  const [quillText, setQuillText] = useState('')
  const { companyId } = useAuth()
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const [storeFileIds, setStoreFileIds] = useState<any>([])
  const [emailData] = useState<any>()
  const [isDiscard, setIsDiscard] = useState<boolean>(false)
  const navigate = useNavigate()
  const location = useLocation()
  const [forwardMessageBody, setForwardMessageBody] = useState<any>()
  const [isSending, setIsSending] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [isActive, setIsActive] = useState(false)
  const [aiEmailResponse, setAiEmailResponse] = useState<string>()
  const [aiEmails, setAiEmails] = useState<any[]>([])
  const [isAiEmailGenerating, setIsAiEmailGenerating] = useState<boolean>(false)
  const [aiPrompt, setAiPrompt] = useState('')

  console.log(lastEmail, ' lastEmail')
  function handleIsActive() {
    setIsActive(() => !isActive)
  }

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setModelStatus(true)
  }
  const handleClose = () => {
    setModelStatus(false)
  }

  const handleRemoveClick = (fileId: string) => {
    setStoreFileIds((prevFiles: any) => prevFiles.filter((file: any) => file.fileId !== fileId))
  }

  const transformField = (ccString: string) => {
    return ccString
      .split(',')
      .map((email) => email.trim())
      .filter((email) => email.length > 0)
      .map((email) => ({ email }))
  }

  const emailSent = async (formik: any, isDraft: boolean) => {
    if (!formik.values.to || formik.values.to.trim() === '') {
      console.log(formik.values.to, ' to')
      formik.setFieldError('to', formatMessage({ id: 'To email is required' }))
      return
    }
    if (isDraft) {
      setIsSaving(true)
    } else {
      setIsSending(true)
    }
    try {
      if (companyId) {
        let payload: any
        if (isForwardEmailClick) {
          console.log('dhdh')
          payload = {
            toEmail: transformField(formik.values.to),
            subject: formik.values.subject,
            body: formik.values.quillText,
            fromEmail: userInfo,
            isDraft: isDraft,
            cc: transformField(formik.values.cc),
            bcc: transformField(formik.values.bcc),
            files: storeFileIds.map((file: any) => file.fileId),
          }
        } else {
          payload = {
            toEmail: transformField(formik.values.to),
            subject: `${subject}`,
            body: formik.values.quillText,
            fromEmail: userInfo,
            isDraft: isDraft,
            cc: transformField(formik.values.cc),
            bcc: transformField(formik.values.bcc),
            replyMessageId: providerEmailId,
            files: storeFileIds.map((file: any) => file.fileId),
          }
        }
        const {
          data: { data, success, errors },
        }: any = await createMessage(companyId, payload)
        if (success) {
          setEmailStatus('INBOX')
          console.log(data)
          toast.success(
            isDraft
              ? formatMessage({ id: 'Email Saved as Draft' })
              : formatMessage({ id: 'Email sent successfully' })
          )
          setIsForwardEmailClick(false)
          handleRedirection('inbox')
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      if (isDraft) {
        setIsSaving(false)
      } else {
        setIsSending(false)
      }
    }
  }

  const getFileIcon = (filename: string) => {
    const extension = filename?.includes('.') ? filename?.split('.').pop()?.toLowerCase() : ''
    let icon
    switch (extension) {
      case 'docx':
      case 'doc':
        icon = docIcon
        break
      case 'pdf':
        icon = pdfIcon
        break
      default:
        icon = imgIcon
        break
    }

    return <img src={icon} alt='Icon' />
  }

  const discard = () => {
    formik.setFieldValue('quillText', '')
    formik.setFieldValue('files', [])
    if (isForwardEmailClick) {
      formik.setFieldValue('subject', '')
      formik.setFieldValue('cc', '')
      formik.setFieldValue('bcc', '')
      formik.setFieldValue('to', '')
    }
    setIsDiscard(true)
  }

  useEffect(() => {
    setIsDiscard(false)
  }, [formik.values])

  // const sendEmailMessage = async (isDraft: boolean) => {
  //   try {
  //     if (companyId) {
  //       let payload: any
  //       payload = {
  //         toEmail: transformField(formik.values.to),
  //         subject: formik.values.subject,
  //         body: formik.values.quillText,
  //         fromEmail: userInfo,
  //         isDraft: isDraft,
  //         cc: transformField(formik.values.cc),
  //         bcc: transformField(formik.values.bcc),
  //         files: storeFileIds.map((file: any) => file.fileId),
  //         threadId,
  //       }
  //       console.log(payload, ' payload')
  //       const {
  //         data: {data, success, errors},
  //       }: any = await createMessage(companyId, payload)
  //       console.log(data)
  //       if (success) {
  //         const {
  //           data: {data1, success, errors},
  //         }: any = await updateMessage(companyId, data.emailRecord.emailMessageId, {
  //           isDraft: false,
  //           threadId: data.emailRecord.providerThreadId,
  //         })
  //         console.log(data, ' datahh')
  //         console.log(data1, ' datahh22')
  //         if (success) {
  //           setEmailStatus('INBOX')
  //           console.log(data)
  //           toast.success(formatMessage({id: 'Email sent successfully'}))
  //           handleRedirection('inbox')
  //         } else {
  //           errors.forEach((error: string) => {
  //             toast.error(formatMessage({id: error}))
  //           })
  //         }
  //         console.log('msg created')
  //       } else {
  //         errors.forEach((error: string) => {
  //           toast.error(formatMessage({id: error}))
  //         })
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }

  const sendEmail = () => {
    // sendEmailMessage(true)
    emailSent(formik, false)
  }

  const handleRedirection = (status: any) => {
    const searchParams = new URLSearchParams(location.search)
    if (searchParams.has('id')) {
      searchParams.delete('id')
    }
    searchParams.set('status', status)
    navigate(`${location.pathname}?${searchParams.toString()}`)
  }
  useEffect(() => {
    if (lastEmail && !isForwardEmailClick) {
      formik.setFieldValue(
        'to',
        lastEmail?.toEmail && lastEmail.toEmail.length > 0
          ? lastEmail.toEmail.map((item: { email: string }) => item.email).join(', ')
          : ''
      )
      formik.setFieldValue('subject', lastEmail.subject)
      formik.setFieldValue(
        'cc',
        lastEmail?.cc && lastEmail.cc.length > 0
          ? lastEmail.cc.map((item: { email: string }) => item.email).join(', ')
          : ''
      )
      formik.setFieldValue(
        'bcc',
        lastEmail?.bcc && lastEmail.bcc.length > 0
          ? lastEmail.bcc.map((item: { email: string }) => item.email).join(', ')
          : ''
      )
      setIsDiscard(true)
      setStoreFileIds([])
      formik.setFieldValue('quillText', '')
    }
  }, [lastEmail, isForwardEmailClick]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (showEmail && showEmail.emailMessageId && isForwardEmailClick) {
      const fromPart = showEmail.fromName
        ? `<a href="mailto:${showEmail.fromEmail}">${showEmail.fromName} <${showEmail.fromEmail}></a>`
        : `<a href="mailto:${showEmail.fromEmail}">${showEmail.fromEmail}</a>`
      const toPart = showEmail.toEmail
        .map((email: any) =>
          email.name
            ? `<a href="mailto:${email.email}">${email.name} <${email.email}></a>`
            : `<a href="mailto:${email.email}">${email.email}</a>`
        )
        .join(', ')
      const forwardedMessage = `<p>---------- Forwarded message ---------</p><p>From: ${fromPart}</p><p>Date: ${DateTime.fromISO(
        showEmail.createdAt
      ).toFormat("EEE, MMM d, yyyy 'at' h:mm a")}</p><p>Subject: ${showEmail.subject
        }</p><p>To: ${toPart}</p><p>${showEmail.body}</p> 
      `
      const fileIds =
        showEmail.sharedInboxAttachments?.map((attachment: any) => attachment.file.fileId) || []
      const fileObjects =
        showEmail.sharedInboxAttachments?.map((attachment: any) => attachment.file) || []
      setForwardMessageBody(forwardedMessage)
      formik.setFieldValue('subject', `Fwd: ${showEmail.subject}`)
      formik.setFieldValue('quillText', forwardedMessage)
      formik.setFieldValue('to', '')
      formik.setFieldValue('cc', '')
      formik.setFieldValue('bcc', '')
      formik.setFieldValue('files', fileIds)
      setStoreFileIds(fileObjects)
    }
  }, [showEmail, isForwardEmailClick]) // eslint-disable-line react-hooks/exhaustive-deps

  const GenerateEmailByAi = async () => {
    setIsAiEmailGenerating(true)
    try {
      const payload = {
        prompt: aiPrompt,
        emailThreadId: providerThreadId,
      }
      const {
        data: { success, errors, data },
      }: any = await createAiComposeEmail(companyId!, payload, 'html')
      if (success) {
        setAiEmails(data.responses.slice(0, 4))
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsAiEmailGenerating(false)
    }
  }
  return (
    <>
      {emailLoading ? (
        <>
          <div className='w-100'>
            <div>
              <Skeleton
                height={300}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </div>
            <div className='mt-2'>
              <Skeleton
                height={100}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </div>
          </div>
        </>
      ) : (
        <>
          {' '}
          <div className='d-block card'>
            <div className='border-bottom'>
              <div className='d-flex align-items-center px-4 min-h-50px'>
                <div className='text-dark fw-bold w-75px'>{formatMessage({ id: 'To:' })}</div>
                <Field
                  type='text'
                  className='form-control border-0 bg-transparent'
                  name='to'
                  disabled={false}
                />
                <div className='ms-auto w-75px text-end'>
                  {(lastEmail?.cc && lastEmail.cc.length > 0) ||
                    (isForwardEmailClick && (
                      <span
                        className={`fw-normal cursor-pointer text-hover-primary me-2  ${showCc ? 'text-primary' : 'text-muted'
                          } `}
                        onClick={() => setShowCc(!showCc)}
                      >
                        {formatMessage({ id: 'Cc' })}
                      </span>
                    ))}
                  {(lastEmail?.bcc && lastEmail.bcc.length > 0) ||
                    (isForwardEmailClick && (
                      <span
                        className={`fw-normal cursor-pointer text-hover-primary me-2  ${showBcc ? 'text-primary' : 'text-muted'
                          } `}
                        onClick={() => setShowBcc(!showBcc)}
                      >
                        {formatMessage({ id: 'Bcc' })}
                      </span>
                    ))}
                </div>
              </div>
              <ErrorMessage name='to' component='div' className='text-danger px-4' />
            </div>

            {showCc && (
              <div className='border-bottom px-4'>
                <div className='d-flex '>
                  <div className='fw-bold w-75px d-flex align-items-center'>
                    {formatMessage({ id: 'CC:' })}
                  </div>
                  <Field
                    type='text'
                    className='form-control border-0 custom-disable bg-transparent'
                    name='cc'
                    disabled={!isForwardEmailClick}
                  />
                </div>

                <ErrorMessage name='cc' component='div' className='text-danger' />
                {/* <span
                    className='btn btn-clean btn-xs btn-icon'
                    onClick={() => setShowCc(false)}
                  >
                    <i className='ki-duotone ki-cross fs-5'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </span> */}
              </div>
            )}
            {showBcc && (
              <div className=' border-bottom px-4'>
                <div className='d-flex'>
                  <div className='text-dark fw-bold w-75px d-flex align-items-center'>
                    {formatMessage({ id: 'BCC:' })}
                  </div>
                  <Field
                    type='text'
                    className='form-control border-0 bg-transparent'
                    name='bcc'
                    disabled={!isForwardEmailClick}
                  />
                </div>

                <ErrorMessage name='bcc' component='div' className='text-danger' />
              </div>
            )}
            <div className='border-bottom d-flex align-items-center px-4'>
              <div className='w-75px text-dark fw-bold'>{formatMessage({ id: 'Subject:' })}</div>
              <Field
                className='form-control fw-normal border-0 min-h-45px bg-transparent'
                name='subject'
                disabled={!isForwardEmailClick}
              />
              <ErrorMessage name='subject' component='div' className='text-danger' />
            </div>
            <div className='border-0 h-250px'>
              {/* <Field
                  className='form-control fw-normal border-0 px-8 min-h-45px'
                  name='body'
                  as='textarea'
                  placeholder={formatMessage({id: 'Enter Your Text Here'})}
                  rows={10}
                /> */}
              <InboxQuill
                quillText={quillText}
                formik={formik}
                setQuillText={setQuillText}
                templateData={isForwardEmailClick ? '' : emailData}
                isDiscard={isDiscard}
                forwardMessageBody={isForwardEmailClick ? forwardMessageBody : ''}
                aiEmailResponse={aiEmailResponse}
              />
              <ErrorMessage name='body' component='div' className='text-danger' />
            </div>
          </div>
          <div className='bg-white border-top'>
            {storeFileIds && storeFileIds.length > 0 && (
              <div className='bg-white px-8 py-8'>
                <div className='d-flex form-label text-dark font-size-13'>
                  {formatMessage({ id: 'Uploaded Files' })}{' '}
                </div>
                <div className='w-100'>
                  <ul className='p-0 m-0'>
                    {storeFileIds.length > 0 &&
                      storeFileIds.map((file: any) => (
                        <li
                          key={file.id}
                          className='d-flex align-items-center gap-2 text-decoration-none mb-2'
                        >
                          {getFileIcon(file.name)}
                          <p className='p-0 m-0'>{file.name.split('/').pop()}</p>
                          <button
                            className='btn btn-secondry p-0 m-0'
                            onClick={() => handleRemoveClick(file.fileId)}
                          >
                            <img src={deleteicon} alt='Delete' />
                          </button>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            )}

            <div className='d-flex flex-stack flex-wrap gap-2 py-5 px-4 bg-white'>
              <div className='d-flex align-items-center'>
                <button
                  type='button'
                  className='btn bg-light custom-button-property fw-normal px-4'
                  onClick={() => discard()}
                >
                  <span className='indicator-label'>{formatMessage({ id: 'Discard' })}</span>
                </button>
              </div>
              <div className='d-flex align-items-center'>
                <button
                  className='btn btn-icon btn-sm btn-clean btn-active-light-primary me-2'
                  onClick={handleOpen}
                >
                  <img src={AttacthmentIcon} alt='' />
                </button>
                <FileUpload
                  fileSize={26214400}
                  maxFileNumber={1}
                  allowType={[
                    'image/*',
                    '.jpg',
                    '.jpeg',
                    '.png',
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  ]}
                  metaData={{ module: 'doc+img', isProtected: true, companyId: companyId }}
                  modalStatus={modelStatus}
                  handleClose={handleClose}
                  handleSuccess={(fileId: number, name: string) => {
                    const newFile = { fileId, name }
                    setStoreFileIds((prevFileIds: any) => [...prevFileIds, newFile])
                  }}
                  resourceType='all'
                />
                <button
                  className='btn bg-primary custom-button-property text-white fw-normal px-6 me-2'
                  type='button'
                  onClick={handleIsActive}
                >
                  <span>
                    {isAiEmailGenerating
                      ? formatMessage({ id: 'Please wait...' })
                      : formatMessage({ id: 'Suggest a reply' })}
                  </span>
                </button>
                {isForwardEmailClick && (
                  <div className='btn-group me-2'>
                    <button
                      type='button'
                      className='btn bg-primary custom-button-property text-white fw-normal px-6'
                      disabled={isSaving}
                      onClick={() => emailSent(formik, true)}
                    >
                      <span className='indicator-label'>
                        {isSaving
                          ? formatMessage({ id: 'Please wait...' })
                          : formatMessage({ id: 'Save As Draft' })}
                      </span>
                    </button>
                  </div>
                )}
                <div className='btn-group'>
                  <button
                    type='button'
                    className='btn bg-primary custom-button-property text-white fw-normal px-6'
                    disabled={isSending}
                    onClick={() => sendEmail()}
                  >
                    <span className='indicator-label'>
                      {isSending
                        ? formatMessage({ id: 'Please wait...' })
                        : isForwardEmailClick
                          ? formatMessage({ id: 'Forward' })
                          : formatMessage({ id: 'Reply' })}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <WriteWithAI
            isActive={isActive}
            setIsActive={setIsActive}
            handleIsActive={handleIsActive}
            setAiEmailResponse={setAiEmailResponse}
            setAiEmails={setAiEmails}
            aiEmails={aiEmails}
            GenerateEmailByAi={GenerateEmailByAi}
            aiPrompt={aiPrompt}
            setAiPrompt={setAiPrompt}
            isAiEmailGenerating={isAiEmailGenerating}
          />
        </>
      )}
    </>
  )
}

export default ReplyEmail
